import { render, staticRenderFns } from "./modal-escoger.vue?vue&type=template&id=3cc887b3&scoped=true"
import script from "./modal-escoger.vue?vue&type=script&lang=js"
export * from "./modal-escoger.vue?vue&type=script&lang=js"
import style0 from "./modal-escoger.vue?vue&type=style&index=0&id=3cc887b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc887b3",
  null
  
)

export default component.exports